// client/src/pages/TermsPage.jsx
import React from "react";
import LegalLayout from "./LegalLayout.jsx";
import LegalPageBody from "./LegalPageBody.jsx";

export default function TermsPage() {
  return (
    <LegalLayout pageKey="terms">
      {({ lang }) => <LegalPageBody slug="terms" lang={lang} />}
    </LegalLayout>
  );
}
